import React from 'react'
import PropTypes from 'prop-types'

import Col from 'component/utils/Col'
import Modal from 'component/utils/Modal'

const DeleteModal = ({ closeModal, remove, translate }) => (
  <Modal size='md' closeModal={closeModal}>
    <h2 className='pricebanner-config-delete-modal-title'>
      <strong>{translate('config.pricebannerConfig.deleteTitle')}</strong>
    </h2>
    <p className='pricebanner-config-delete-modal-content'>
      {translate('config.pricebannerConfig.deleteContent')}
    </p>
    <Col xsOffset={2} xs={4} className='margin-top-double'>
      <button
        onClick={closeModal}
        type='button'
        className='button-hollow button-hollow-primary full'
      >
        <strong>{translate('cancel_button')}</strong>
      </button>
    </Col>
    <Col xs={4} className='margin-top-double'>
      <button
        onClick={remove}
        type='button'
        className='button button-dark-danger full'
      >
        {translate('button.yes.remove')}
      </button>
    </Col>
  </Modal>
)

DeleteModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  remove: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
}

export default DeleteModal
